import {
  CreateTenantPayload,
  CreateTenantResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useCreateTenant(
  onSuccess?: (data: CreateTenantResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants`;

  const request = new Request(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<CreateTenantResponse, CreateTenantPayload>(
    request,
    {
      onSuccessInvalidationKeys: [['admin-tenants']],
      onSuccess,
      onError,
    }
  );
}

export default useCreateTenant;
